import * as R from 'ramda'

/********************
 * Get
 * filterEle : 폼에서 제외하고 싶은 요소(배열)  
 * ******************/
const getFormData = (form, filterEle) => {
    let form_data = new FormData(form)
    
    let data = serialize(form_data, filterEle)

    return JSON.stringify(data)
}

const serialize = (data, filterEle =[]) => {
    let reData = {}

    for(let [key, value] of data) { 
        if(!filterEle.includes(key)){
            value = value.replaceAll("@", "*")
            value = jsonParserByString("sp", value);

            if(reData[key] || reData[key] === '') {
                reData[key] += '@' + value
            }else {
                reData[key] = value
            }
        }
    }

    return reData
}


//특수문자 특정문자로 치환
const jsonParserByString = (type, str) => {
	if(type === "sp"){
		str = str.replace(/\"/gi, "-AA")
		str = str.replace(/\'/gi, "-AB")
		str = str.replace(/\//gi, "-AC")		
	}
	else{		
		str = str.replace(/-AA/gi, "\"")
		str = str.replace(/-AB/gi, "\'")
		str = str.replace(/-AC/gi, "\/")	
	}
	
	return str
}



/********************
 * Set
 * ******************/
const setFormData = (form, data, target_id, template) => {
    if(form && data) {
        data = data.replace(/\r\n/gi, "\\r\\n");
        
        let form_data = JSON.parse(data)

        if(template) {
            for(let key of Object.keys(form_data)) {
                if(form_data[key].indexOf("@") !== -1) {
                    for(let i=0; i<form_data[key].split("@").length-1; i++) {
                        setFormTemplate(form, target_id, template)
                    }
                    break
                }
            }
        }

        for(let key of Object.keys(form_data)) {
            setFormValueByTag(form, key, form_data[key])
        }
    }
}

const setFormValueByTag = (form, key, value) => {
    let tag = form.querySelectorAll('input[type="text"][name="' + key + '"]')
    if(tag.length > 0) {
        if(value.indexOf("@") !== -1) {
            for(let i=0; i < value.split("@").length; i++) {
                tag[i].value = value.split("@")[i].replace("*", "@")
            }
        }else {
            tag[0].value = value.replace("*", "@")
        }
    }
    tag = form.querySelectorAll('input[type="number"][name="' + key + '"]')
    if(tag.length > 0) {
        if(value.indexOf("@") !== -1) {
            for(let i=0; i < value.split("@").length; i++) {
                tag[i].value = value.split("@")[i]
            }
        }else {
            tag[0].value = value
        }
    }
    tag = form.querySelectorAll('input[type="hidden"][name="' + key + '"]')
    if(tag.length > 0) {
        if(value.indexOf("@") !== -1) {
            for(let i=0; i < value.split("@").length; i++) {
                tag[i].value = value.split("@")[i]
            }
        }else {
            tag[0].value = value
        }
    }
    tag = form.querySelectorAll('input[type="radio"][name="' + key + '"]')
    if(tag.length > 0) {
        for(let o of tag) {
            if(o.value === value) {
                o.checked === true
            }
        }
    }
    tag = form.querySelectorAll('input[type="checkbox"][name="' + key + '"]')
    if(tag.length > 0) {
        if(value.indexOf("@") !== -1) {
            for(let o of tag) {
                for(let v of value.split("@")) {
                    if(o.value === v) {
                        o.checked = true
                    }
                }
            }
        }else {
            tag[0].value = value
        }
    }
    tag = form.querySelectorAll('select[name="' + key + '"]')
    if(tag.length > 0) {
        if(value.indexOf("@") !== -1) {
            for(let i=0; i < value.split("@").length; i++) {
                tag[i].value = value.split("@")[i]
            }
        }else {
            tag[0].value = value
        }
    }
    tag = form.querySelectorAll('textarea[name="' + key + '"]')
    if(tag.length > 0) {
        if(value.indexOf("@") !== -1) {
            for(let i=0; i < value.split("@").length; i++) {
                tag[i].value = value.split("@")[i].replace("*", "@")
            }
        }else {
            tag[0].value = value.replace("*", "@")
        }
    }
}

//template 세팅
const setFormTemplate = (form, target_id, template) => {
    if(form) {
        let tmpl = document.createElement('tr');
        tmpl.innerHTML = template
        if(target_id) {
            form.querySelector(target_id).appendChild(tmpl)
        }else {
            form.appendChild(tmpl)
        }
    }
}


export { getFormData, setFormData, setFormTemplate }